import React, { useState, useEffect } from 'react';
import { preferencesGroupsStorage } from '../../services/preferencesGroupsStorage';
import PreferenceGroupsListItemContent from './PreferenceGroupsListItemContent';
import Checkbox from "../Checkbox";

const isGroupSelected = (groupId) =>
    preferencesGroupsStorage.getSelectedList().some((it) => it.id === groupId);

const PreferenceGroupsListItem = ({ group }) => {
    const [isChecked, setIsChecked] = useState(() => isGroupSelected(group.id));

    useEffect(() => {
        const sync = () => setIsChecked(isGroupSelected(group.id));
        preferencesGroupsStorage.registerFiltersChangingObserver(sync);
        sync();
        return () => preferencesGroupsStorage.unRegisterFiltersChangingObserver(sync);
    }, [group.id]);

    return (
        <>
            <li className="preference__list-item preference__groups-item">
                <div
                    onClick={(event) => event.stopPropagation()}
                    onKeyDown={(event) => event.stopPropagation()}
                >
                    <Checkbox
                        checked={isChecked}
                        handleChecked={() =>
                            preferencesGroupsStorage.changeSelectedPreferenceGroups(group.id)
                        }
                    />
                </div>
                <PreferenceGroupsListItemContent group={group} />
            </li>
        </>
    );
};

export default PreferenceGroupsListItem;
